/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Pm } from './Pm';

class LiveGoods extends Pm {
    constructor() {
        super();
        this.baseUrl += '/liveGoods';
    }

    data({ goodsName, goodsStatus, liveRoomId, liveRoomIdNe, currentPage, pageSize } = {}) {
        return super.get('/data', {
            goodsName,
            goodsStatus,
            liveRoomId,
            liveRoomIdNe,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const coverImageUrl = json.data.data.liveGoods.coverImageUrl;
            const fileBasePath = json.data.data.filePath;
            if (!coverImageUrl) {
                json.data.data.liveGoods.coverImageUrl = [];
            } else {
                json.data.data.liveGoods.coverImageUrl = coverImageUrl.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({ id, shopGoodsId, goodsName, coverImageUrl, priceType, goodsPrice, remarks, goodsStatus } = {}) {
        const coverImageUrlStr = coverImageUrl
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            id,
            shopGoodsId,
            goodsName,
            coverImageUrl: coverImageUrlStr,
            priceType,
            goodsPrice: JSON.stringify(goodsPrice),
            remarks,
            goodsStatus,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    resetAudit({ ids } = {}) {
        return super.post('/resetAudit', {
            ids,
        });
    }
}

export default new LiveGoods();
export { LiveGoods };
